export const _setNewReferralSourceForm = (state, action) => {
  state.newReferralSourceForm = action.payload;
};

export const _setOrgId = (state, action) => {
  state.orgId = action.payload;
};
